module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point4_2-abeadc431ae952f79f847b79a2d72f5f.jpg";